var map = {
	"./de.json": [
		6477,
		[
			477
		]
	],
	"./fr.json": [
		4554,
		[
			554
		]
	],
	"./it.json": [
		6851,
		[
			851
		]
	],
	"./pt.json": [
		4606,
		[
			225
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1803;
module.exports = webpackAsyncContext;